// extracted by mini-css-extract-plugin
module.exports = {"inspect-header":"inspect-header___QaTA9"};